import React from 'react';

const AppleIcon: React.FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4932 15.3581C11.6222 16.2024 10.6712 16.0691 9.75577 15.6691C8.787 15.2603 7.89822 15.2425 6.87613 15.6691C5.59629 16.2202 4.92082 16.0602 4.15647 15.3581C-0.180758 10.8875 0.459162 4.07948 5.38299 3.83063C6.58283 3.89284 7.41828 4.48832 8.12042 4.54165C9.16917 4.32834 10.1735 3.71509 11.2934 3.79508C12.6354 3.90173 13.6486 4.435 14.3152 5.39487C11.5422 7.05689 12.1999 10.7098 14.7418 11.7319C14.2352 13.065 13.5775 14.3893 12.4843 15.367L12.4932 15.3581ZM8.03154 3.7773C7.89822 1.79533 9.50691 0.15998 11.3556 0C11.6133 2.29304 9.27583 3.9995 8.03154 3.7773Z"
        fill="black"
      />
    </svg>
  );
};

export default AppleIcon;
